export default __webpack_public_path__ + "static/media/brush-alt.e7ed3169.svg";